import React from 'react';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { TabWrapper } from '../../AccountForm.styles';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnership />
      <AccountDescription />
    </TabWrapper>
  );
};

export const DefaultForm = (props: FormComponentProps) => {
  return <TabsContent {...props} tabs={[{ name: 'Summary', Component: Summary }]} />;
};
